import { render, staticRenderFns } from "./TestbankHistoryQuestionChoice.vue?vue&type=template&id=50909505&"
import script from "./TestbankHistoryQuestionChoice.vue?vue&type=script&lang=js&"
export * from "./TestbankHistoryQuestionChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50909505')) {
      api.createRecord('50909505', component.options)
    } else {
      api.reload('50909505', component.options)
    }
    module.hot.accept("./TestbankHistoryQuestionChoice.vue?vue&type=template&id=50909505&", function () {
      api.rerender('50909505', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/History/TestbankHistoryQuestionChoice.vue"
export default component.exports